import { useDocumentMutation } from "web_myplann/Api/Document/useDocumentMutation";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { device } from "web_myplann/Utils/device";

export const useSaveDocumentMutation = () =>
	useDocumentMutation<string[]>({
		errorResource: Resources.Common.documentSaveFailed,
		deliver: async ({ filename, base64 }, errorMessage) => {
			const response = await device.saveAttachment({ filename, base64 });

			if (!response.payload.success) {
				throw new Error(errorMessage);
			}

			return response.payload.downloaded;
		},
	});
